import * as angular from "angular";
import {IController} from "angular";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {$rulesFactory} from "../../$rules.factory";
import {RulesService} from "../../services/rules.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class RulesViewComponent implements IController {

  dateRangeTemplateType: DateRangeTemplateType;
  from: number;
  to: number;

  private filterConfig = {
    customTemplates: undefined,
    queryString: undefined,
    bringozFilters: {
      dateRangeTemplateType: undefined
    },
    // range: {
    //   name: undefined,
    //   dateStart: undefined,
    //   dateEnd: undefined
    // },
    // rangeLimit: {
    //   min: undefined,
    //   max: undefined
    // },
    siteId: undefined,
  };

  private blockingSearchDatesRangeLimit: number;
  private infiniteScroll;
  private rulesRef: any;
  private loadLimit: number = 20;


  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private splitService: SplitService, private moment,
              private $state, private $infiniteScroll, private $rules: $rulesFactory, private $log, private confirmDialogService: ConfirmDialogService,
              private rulesService: RulesService) {
  }

  $onInit() {

    this.filterConfig.siteId = this.splitService.getSiteId();

    //
    // this.filterConfig.range = this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
    //   ((this.from && this.to) ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today());
    // this.blockingSearchDatesRangeLimit = this.splitService.getBlockingSearchDatesRangeLimit();
    //
    // this.filterConfig.range = this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
    //   ((this.from && this.to) ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today());
    //
    // this.filterConfig.rangeLimit = {
    //   min: !this.blockingSearchDatesRangeLimit ? undefined : this.moment().subtract(this.blockingSearchDatesRangeLimit, 'day').startOf('day').valueOf(),
    //   max: undefined,
    // };

    this.rulesRef = this.$rules();
    this.rulesRef.$query(this.getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.rulesRef, this.loadLimit, {getFullData: true});


  }

  submitQuery(queryString: string) {
    this.filterConfig.queryString = queryString;
    this.reloadQuery();
  }

  // onRangeChanged(range) {
  //   if (!_.isUndefined(range) && !_.isEqual(range.name, this.filterConfig.range.name)) {
  //     this.filterConfig.range = range;
  //     this.filterConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
  //     this._setStateParams();
  //     this.reloadQuery();
  //   }
  // }

  onEditRule(ruleId: string) {
    this.$state.go('rule.edit', {id: ruleId});
  }

  onDeleteRule(ruleId: string, event) {
    this.confirmDialogService.confirm('Delete rule', 'Are you sure you want to delete this rule?', event)
      .then(() => {
        this._deleteRule(ruleId);
      })
  }

  private _deleteRule(ruleId) {
    this.rulesService.deleteRule(ruleId)
      .then(() => this.reloadQuery());
  }

  // private _setStateParams() {
  //   this.$state.go('.', {
  //     dateRangeTemplateType: this.filterConfig.bringozFilters.dateRangeTemplateType,
  //     from: this.filterConfig.range.dateStart,
  //     to: this.filterConfig.range.dateEnd,
  //   }, {notify: false, reload: false, location: 'replace'});
  // }

  private reloadQuery() {
    this.rulesRef.$query(this.getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private getQueryPayload() {
    return {
      // from: this.filterConfig.range.dateStart,
      // to: this.filterConfig.range.dateEnd,
    }
  }


}


angular
  .module('bringoz.admin.ruleEngine')
  .component('rulesView', {
    bindings: {
      dateRangeTemplateType: '<',
      from: '<',
      to: '<'
    },
    template: require('./rules-view.html').default,
    controller: RulesViewComponent
  });

